import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Fetch, API_BASE, authHeaders } from '../../utils/Utils.js';
import './FinanceCurrencySettings.css';

const FinanceCurrencySettings = () => {
  const { t } = useTranslation();
  const [currency, setCurrency] = useState('BRL');
  const [settingsId, setSettingsId] = useState(null);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    Fetch('api/data/account.settings', 'GET', null,
      (data) => {
        const s = Array.isArray(data) ? data[0] : data;
        if (s) {
          if (s.currency) setCurrency(s.currency);
          if (s._id) setSettingsId(s._id);
        }
      },
      () => {}
    );
  }, []);

  const saveCurrency = (value) => {
    setCurrency(value);
    setSaved(false);
    const method = settingsId ? 'PATCH' : 'POST';
    const body = settingsId ? { _id: settingsId, currency: value } : { currency: value };
    fetch(`${API_BASE}/api/data/account.settings`, {
      method,
      headers: authHeaders({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(body),
    }).then(r => { if (r.ok) setSaved(true); });
  };

  return (
    <div className="currency-settings-page">
      <div className="currency-settings-card">
        <label className="currency-settings-label">{t('currency')}</label>
        <div className="currency-settings-row">
          <select
            className="currency-settings-select"
            value={currency}
            onChange={e => saveCurrency(e.target.value)}
          >
            <option value="BRL">{t('currency_brl')}</option>
            <option value="USD">{t('currency_usd')}</option>
          </select>
          {saved && <span className="currency-settings-saved">✓</span>}
        </div>
      </div>
    </div>
  );
};

export default FinanceCurrencySettings;
